var exports = {
  "kL": "x127c5a35--20409d--container",
  "a3": "x127c5a35--20409d--added_info",
};

module.exports = exports;
